import React from 'react';
import clsx from 'clsx';
import { MessageDescriptor, useIntl } from 'react-intl';
import type { ReleaseCategory, ResolvedReleaseEntry } from 'fym-shared/src/releases/types';
import { TypedMemo } from '../../common/types';
import { whatsNewMessages as m } from './whatsNewMessages';
import { withBrandWord } from '../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel; each part uses its own slice of it */
import styles from './WhatsNew.module.scss';
/* eslint-enable css-modules/no-unused-class */

const CATEGORY_LABEL: Record<ReleaseCategory, MessageDescriptor> = {
  feature: m.categoryFeature,
  improvement: m.categoryImprovement,
  fix: m.categoryFix,
};

const CATEGORY_CLASS: Record<ReleaseCategory, string | undefined> = {
  feature: styles.categoryFeature,
  improvement: undefined,
  fix: styles.categoryFix,
};

interface Props {
  entry: ResolvedReleaseEntry;
}

/** One plain row under "Also in this version" (design whats-new a2): the category chip, the title and the body. */
const WhatsNewEntryRowComponent: React.FC<Props> = ({ entry }) => {
  const intl = useIntl();
  return (
    <li className={styles.row}>
      <b className={clsx(styles.category, CATEGORY_CLASS[entry.category])}>
        {intl.formatMessage(CATEGORY_LABEL[entry.category])}
      </b>
      <b className={styles.rowTitle}>{withBrandWord(entry.title)}</b>
      <p className={styles.rowBody}>{withBrandWord(entry.body)}</p>
    </li>
  );
};

export const WhatsNewEntryRow = TypedMemo(WhatsNewEntryRowComponent);
